import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { ContactAddressType } from '../common/ContactAddress.type'
import { selectAllContacts } from '../slices/contactAddressSlice'
import { useProcessContactAddress } from './fetch/contactAddress/useProcessContactAddress'
import useNavigatePrevPage from './useNavigatePrevPage'

const useImportFile = () => {
  const [uploadData, setUploadData] = useState<ContactAddressType[]>([])
  const navigate = useNavigate()

  const { pathname } = useLocation()

  const selectAllContactAddress = useSelector(selectAllContacts)

  const { registContactAddress, updateContactAddress } =
    useProcessContactAddress()

  const upload = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    baseUrl: string,
  ) => {
    if (baseUrl === '/contactAddress') {
      for (const currAddress of uploadData) {
        if (
          selectAllContactAddress.some(
            (address) => address.id === currAddress.id,
          )
        ) {
          let birthday = null

          if ('birthday' in currAddress) {
            const isValidBirthday = Date.parse(currAddress.birthday as string)

            if (isValidBirthday) {
              birthday = new Date(Date.parse(currAddress.birthday as string))
                .toISOString()
                .split('T')[0]
            }
          }

          const updatedContactAddress = {
            ...currAddress,
            birthday,
            isFavorite: currAddress?.isFavorite || false,
          }

          updateContactAddress(e, updatedContactAddress)
        } else {
          const { id, ...restAddress } = currAddress

          let birthday = new Date().toISOString().split('T')[0]
          if ('birthday' in restAddress) {
            const isValidBirthday = Date.parse(restAddress.birthday as string)

            if (isValidBirthday) {
              birthday = new Date(Date.parse(restAddress.birthday as string))
                .toISOString()
                .split('T')[0]
            }
          }

          const registeredContactAddress = {
            ...restAddress,
            birthday,
            isFavorite: currAddress?.isFavorite || false,
          }

          registContactAddress(e, registeredContactAddress)
        }
      }
    }

    navigate(baseUrl)
  }

  const baseUrl = '/' + pathname.split('/').slice(1)[0]
  const { navigatePrevPage } = useNavigatePrevPage()

  return {
    uploadData,
    setUploadData,
    upload,
    baseUrl,
    navigatePrevPage,
  }
}

export default useImportFile
